import React from 'react'
import { useRuleDetailContextValue } from '../../context/RuleDetailProvider'
import { DeleteRateConfirmFlowProvider } from './context/DeleteRateConfirmFlowProvider'
import { DeleteRateConfirmFlowMain } from './components/DeleteRateConfirmFlowMain'

export const DeleteRateConfirmFlow = () => {
  const {
    state: { id: ruleId },
  } = useRuleDetailContextValue()

  return (
    <DeleteRateConfirmFlowProvider ruleId={ruleId}>
      <DeleteRateConfirmFlowMain />
    </DeleteRateConfirmFlowProvider>
  )
}
